<div class="container d-flex align-items-center py-4 h-100">

    <main class="form-signin w-100 m-auto">
        <form data-bitwarden-watching="1" #loginForm="ngForm">
            <h1><i class="fa-solid fa-qrcode my-3 me-2"></i><span class="manual">Manual</span>Radar</h1>

            <div class="form-floating">
                <input type="password" class="form-control" id="floatingPassword" name="password" [(ngModel)]="password" placeholder="Passwort" (keyup.enter)="login()" required>
                <label for="floatingPassword">Passwort</label>
            </div>

            <button class="btn btn-warning w-100 mt-3 py-2" type="button" [disabled]="loginForm.invalid"
                    (click)="login()">Anmelden</button>
        </form>
    </main>
</div>
